"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  ops: {
    crs: '航向',
    isInReport: 'Is it stored in the warehouse',
    agingDays: 'Aging days',
    feeStatus: 'Fee status',
    feeSettingRemind: 'Fee setting reminder',
    viscosity: 'viscosity',
    sulfurQty: 'sulfurQty',
    consumeMgo: 'Light fuel consumption (high/low)',
    consumeFo: 'Heavy fuel consumption (high/low)',
    storeMgo: 'Storage of light oil (high/low)',
    storeFo: 'Heavy oil storage (high/low)',
    avgSpd: 'speed',
    height: 'Wave force',
    waveDir: 'wave direction',
    scale: 'wind power',
    direction: 'wind direction',
    avgRevolutionPerMin: 'speed',
    longitude: 'longitude',
    latitude: 'latitude',
    reportTm: 'report Time',
    type: 'report Type',
    reportStatus: 'report Status',
    noCheck: 'No check',
    portStatus: 'status',
    isFutures: 'Is Futures',
    escrowShipOwnerTo: 'Escrow ship owner to',
    escrowVoyageType: 'Escrow Voyage Type',
    offsetCompany: 'offsetCompany',
    docNo: 'DocNo',
    updateVesselName: 'update vesselName',
    portKnowledgeBase: 'portKnowledgeBase',
    portNotHasTimeZone: 'Please maintain the time zone of the port first',
    countFuelConsumeSuccess: 'Calculate fuel consumption Success',
    countFuelConsume: 'Calculate fuel consumption',
    oilCalRate: 'Fuel calculation ratio',
    portInformation: 'Port information',
    isReceivedNotDel: 'is Received Not Delete',
    specialStatus: 'Speical Status',
    sailStatus: 'Sail Status',
    messagrAB: 'The cancellation of the voyage was successful',
    messageSpeed: 'The super low speed state is successfully changed. Procedure',
    messageSpeedB: 'CUT_OUT The entry is modified successfully',
    messageSpeedC: 'The LOI status was changed successfully. Procedure',
    messageSpeedD: 'The status of the internal sublease contract was modified successfully',
    vesselCode: 'Vessel Code',
    fuelstrocknoonreportquery: 'Fuelstrocknoonreportquery',
    vesselNameEn: 'Vessel Name En',
    fuelStockNoonQuantity: 'Fuel Stock Noon Quantity',
    hsfoQuantity: 'Hsfo Quantity',
    lsfoQuantity: 'Lsfo Quantity',
    hsmgoQuantity: 'Hsmgo Quantity',
    lsmgoQuantity: 'Lsmgo Quantity',
    vesselNameCn: 'Vessel Name Cn',
    isAuto: 'Automatically stocked in or not',
    tipsPortEvent: 'Port name or country, one of which is required',
    remark02: 'Maintenance content',
    title: 'title',
    fuelConfirmation: 'Fuel confirmation',
    fuelConfirmationSuccess: 'Fuel confirmation success',
    fuelConfirmationFail: 'Fuel confirmation fail',
    fuelRollback: 'Fuel rollback',
    fuelRollbackSuccess: 'Fuel rollback success',
    fuelRollbackFail: 'Fuel rollback fail',
    mustReceivedInitOil: 'Initialization oil not signed for, unable to add',
    hasCodeNotCommon: 'Miscellaneous fees with different business scenarios',
    hasTypeNotCommon: 'There are miscellaneous fees with different contract types',
    initPortNotDel: 'The initialized port cannot be deleted',
    codeIsNotCommon: 'There is a situation where the business scenario code is inconsistent and cannot be generated',
    saveWarning: 'Save successfully',
    newShipName: 'Name of ship',
    //saveWarning:'Save successfully',
    pleaseChooseContract: 'Please Choose Contract',
    vcContract: 'VC-Contract',
    tcContract: 'TC-Contract',
    poolContract: 'POOL-Contract',
    arrivalNotDel: 'It has actually arrived at the port and cannot be deleted',
    limitTwoMessage: 'Add up to two',
    haveInContractTip: 'A charter party already exists and cannot be imported',
    haveOutContractTip: 'A chartering party contract already exists and cannot be imported',
    mustOboContractTip: 'Only allow adding OBO contracts',
    noOboContractTip: 'Only allow adding charter party contracts',
    tips: 'tips',
    isReceived: 'Sign for or not',
    receivedSuccess: 'Received success',
    receivedFail: 'Received Fail',
    isNotReceived: 'Whether to cancel receipt',
    notReceivedSuccess: 'Not Received success',
    notReceivedFail: 'Not Received fail',
    startPortAndOilDetail: 'StartPort And Oil Detail',
    editOilDetail: 'Initialize oil storage modification',
    sign: 'sign',
    noSign: 'Reverse Receipt',
    voyagePlane: 'Voyage plan',
    voyageTime: 'Voyage time',
    oneContract: 'Ship dispatching management',
    pleaseAssContract: 'Please Association Contract',
    editRate: 'Rate editor',
    messageD: 'Select the data you want to delete',
    unitPrice4: 'price',
    noSpecialSuccess: 'No Special Success',
    noSpecialFail: 'No Special Fail',
    payId: 'payer',
    hasAudited: 'The existence status is approved and cannot be deleted',
    exportError: 'The imported data cannot be imported repeatedly',
    opsError: 'Please select one payee and one currency',
    warningPleaseSelect02: 'The ship has arrived at the port, or the first port cannot be inserted into the port',
    errorVoyage: 'Please maintain the cargo information of the voyage first, or the port of discharge is empty in the cargo information of the voyage, otherwise the cargo quantity of the bill of lading cannot be obtained',
    textTitle: '',
    handleVoyageEndOpen: 'Cancel the voyage',
    freightRate: 'Freight rate',
    priceOne: 'Unit price',
    messagrC: 'Please first carry out the contract return ship status operation',
    portMessage1: 'All ports require physical arrival and physical departure',
    ExpenseitemOne: 'demurrage',
    ExpenseitemTwo: 'Demurrage has been calculated',
    voyageRemarkOne: 'Voyage remarks added',
    successpre: 'The voyage switch succeeded',
    addSpace: 'Add',
    deleteSpace: 'Delete',
    remorkSpac: 'Special event record',
    evebtDetail: 'Event Details',
    exemptConType: 'Ensure Exemption Con',
    extraTimeFlag: 'Extra Time',
    extraCon: 'Extra Con',
    EndSpac: 'End Time',
    beginTimeSpac: 'Begin Time',
    makeDateTime: 'Record Time',
    evebtType: 'Event Type',
    specialDetail: 'Special event details',
    retiredSuccess: 'Retired Success',
    retiredFail: 'Retired Fail',
    addBillOfLoading: 'New Bill of Lading',
    searchTemplate: 'Search Template',
    addTemplate: 'Add Template',
    noSpecial: 'No special event records',
    specialEventRecords: 'Special event records',
    actTotalOffhire: 'Actual Total Deduction Fee',
    actTotalOil: 'Actual Oil Consumptio',
    actTotalRent: 'Actual Deduction Amount',
    actOffHireDays: 'Actual calculation Off Hire Days',
    actDateOne: 'Actual Settlement Date',
    estTotalOffhire: 'Estimated Total Deduction Fee',
    estTotalRent: 'Estimated Oil Consumption Loss',
    estDailyRent: 'Estimated Deduction Amount',
    estOffHireDays: 'Estimated calculation Off Hire Days',
    ballastTime: 'Duration In Ballast',
    ballastMile: 'Mileage In Ballast ',
    estDate: 'Estimated Settlement Date',
    dailyRent: 'Daily Rent',
    proRate: 'Off Hire Proportion',
    oilType: 'Fuel type',
    totalConsume: 'Fuel consumption',
    priceOil: 'price',
    // totalFee: 'expense',
    lockSuccess: 'Lock Success',
    unLockSuccess: 'UnLock Success',
    lockFail: 'Lock Fail',
    unLockFail: 'UnLock Fail',
    unLock: 'unLock',
    lock: 'lock',
    //proRate: 'OffHire Proportion',
    //dailyRent: 'Daily Rent',
    //estDate: 'Estimated Settlement Date',
    offhireDays: 'Estimated calculation Off Hire Days',
    discardSuccess: 'Discard Success',
    discardFail: 'Discard Fail',
    examineSuccess: 'Examine Success',
    examineFail: 'Examine Fail',
    reverseExamineSuccess: 'Reverse Examine Success',
    reverseExamineFail: 'Reverse Examine Fail',
    upSuccess: 'Port Up Success',
    downSuccess: 'Port Down Success',
    notLastTips: 'This port is the last port on the voyage and cannot be moved down',
    preIsArrTips: 'The previous port is not an estimated port and cannot be moved up',
    isArrTips: 'Actual arrival, cannot be adjusted',
    notFirstTips: 'This port is the first port on the voyage and cannot be moved up',
    settleStatus: 'Payment',
    paymentApplicationId: 'petty cash',
    checkFlag: 'Approve',
    baseAmount: 'USD amount',
    amount01: 'Estimated amount',
    currencyName: 'Currency',
    an: 'agentCode-agentName',
    relatedParties: 'Evaluation of interested parties',
    noticeEstimateTrue: 'Notify the agent to fill in the estimate',
    portFeeEstimateTrue: 'Estimated port charges True',
    portFeeEstimate: 'Estimated port charges',
    warningPleaseSelect: 'Please Select One',
    warningSelectOne: 'Only Select One',
    editAgentInfo: 'Edit agent information',
    localAgentSetCenter: 'Local agent as settlement center',
    owner: 'Owner',
    charterer01: 'charterer',
    subCharterer: 'sub-Charterer',
    chrgName: 'Contact By',
    agentFeePay: 'Agent Payer',
    agentBy: 'Agent By',
    agentType: 'Agent Type',
    agentName: 'Settlement Center',
    localAgentName01: 'Local Agent Name',
    localAgentName: 'Local Agent Name',
    agentInfo: 'Agent Information',
    portCode02: 'Port',
    portCode01: 'Port Code',
    days: 'Days',
    portAgentDetail: 'Port Agent Detail',
    codeInShipLine: 'code',
    enNameInShipLine: 'En Name',
    compLt: 'Voyage End Time',
    ispFleetCode: 'Fleet Name',
    shipRepairDedInfo: 'Ship repair deduction information',
    fuelLossInformation: 'Fuel loss information',
    rentLossInformation: 'Rent loss information',
    loseOffHire: 'Loss information of off-hire and suspension of navigation',
    isBunker: 'Loss Of Oil Consumption Count Operating Account',
    isOffHireDays: 'Count Non-Operating Days',
    isOffHire: 'Loss Of Hire Count Operating Account ',
    beginDoH: 'Star Hsmgo',
    beginDoL: 'Star Lsmgo',
    beginFoH: 'Star Hsfo',
    beginFoL: 'Star Lsfo',
    endDoH: 'End Hsmgo',
    endDoL: 'End Lsmgo',
    endFoH: 'End Hsfo',
    endFoL: 'End Lsfo',
    north: 'north',
    south: 'south',
    west: 'west',
    east: 'east',
    beginLat: 'Start Latitude',
    beginLong: 'Start Longitude',
    beginTime_LT: 'Start Local Time(LT)',
    beginTimeZone: 'Time Zone',
    beginTime_GMT: 'Start Local Time(GMT)',
    beginPortCode: 'Start Port',
    endLat: 'End Latitude',
    endLong: 'End Longitude',
    endTime_LT: 'End Local Time(LT)',
    endTimeZone: 'Time Zone',
    endTime_GMT: 'End  Local Time(GMT)',
    endPortCode: 'End Port',
    startPortInformation: 'Start Port Information',
    endPortInformation: 'End Port Information',
    estimateLockUser: 'Estimate Lock User',
    estimateLockTime: 'Estimate Lock Time',
    actualLockUser: 'Actual Lock User',
    actualLockTime: 'Actual Lock Time',
    shipRepairLocale: 'Ship Repair Locale',
    actualInfo: 'Actual information',
    estimatedInfo: 'estimated Information',
    offHireAndOffFlightInfo: 'offHireAndOffFlight Information',
    offHireAndOffFlightMaintain: 'offHireAndOffFlight Maintain',
    day: 'Days',
    beginDate: 'Begin Time',
    endDate: 'End Time',
    reportTime: 'report Time',
    cause: 'Off Hire Type',
    startTime02: 'Start Time',
    endTime02: 'End Time',
    speed02: 'Speed',
    speedType: 'Speed Type',
    isPayByOtherDept: 'isPayByOtherDept',
    toComm: 'Brokerage ',
    advanceAmount: 'Advance Amount',
    invoiceNo: 'Invoice No',
    invoiceDate: 'Invoice Date',
    stockStatus: 'Stock Status',
    flowTime: 'Flow Time',
    batchNo: 'Batch No',
    quantity: 'quantity',
    bunkerSpec: 'Oil Type',
    operationType: 'Operation Type',
    operationNo: 'Operation No',
    submitSuccess: 'Submit business',
    discard: 'discard',
    riskScreening: 'Risk screening',
    shipMaintenance: 'ship Maintenance',
    shipAccident: 'ship Accident',
    offHireAndOffFlight: 'Off hire and off flight',
    portKnowledge: 'Port knowledge base',
    shipSpeed: 'speed of a ship or plane',
    voyageAccount: 'Voyage Account',
    voyageSundryFee: 'Voyage Sundry Fee',
    voyageSundryFeeMaintain: 'Voyage miscellaneous maintenance',
    message: 'message',
    fuelStock: 'Fuel Stock',
    abandon: 'state',
    toArap: 'Receivables and Payables',
    toFrt: 'InvoiceNo',
    examine: 'examine',
    reverseExamine: 'Reverse Examine',
    advance: 'advance',
    payDeadline: 'Payment Deadline',
    payee: 'payee',
    amountInVoyage: 'amount',
    describe: 'Describe',
    feeType: 'Expense Type',
    feeType2: "<label style='color:red'>*</label> Expense Type",
    rpFlag: 'Receipt Or payment',
    addWaterRemark: 'remarks',
    currencyInWater: 'currency',
    actualQuantityWater: 'Actual Quantity Water',
    cashPay: 'Cash Pay',
    portPay: 'Port Pay',
    my: 'My',
    other: 'Their',
    addWaterPort: 'Add Water Port',
    addFoTime: 'Add FO Time',
    addFoQuantity: 'Add FO Quantity',
    foPrice: 'FO Price',
    addMgoQuantity: 'Add MGO Quantity',
    mgoPrice: 'MGO Price',
    addWaterQuantity: 'Add Water Quantity',
    waterPrice: 'Water Price',
    totalFee: 'Total Fee',
    spContractNo: 'SP Contract No',
    approveStatus: 'Approve Status',
    approveNo: 'Approve No',
    addOilAndWater: 'Add Oil And Water',
    addWaterDetail: 'Add Water Detail',
    addWaterInfo: 'Add Water Information',
    addOil: 'Add Oil',
    addWater: 'Add Water',
    dispatchingManagement: 'ops',
    vesselFuelManagement: 'Vessel Fuel Management',
    fuelFuturesContract: 'Fuel Futures Contract',
    fleet: 'Fleet',
    prVesselName: 'Vessel Name',
    vessel: 'vessel Name',
    prVesselNameInDetail: 'vessel Name',
    contractNo: 'Contract No',
    supplierName: 'Supplier Name',
    traderName: 'trader Name',
    supplierRemarks: 'Supplier Remark',
    oilNameAndSpec: 'Spec',
    contractDate: 'Contract Date',
    orderDate: 'Ordering date',
    number: 'No',
    actualRefuelingDate: 'Actual Refueling Date',
    fuelFuturesContractDetail: 'Fuel Futures Contract Detail',
    contractInfo: 'Contract Information',
    contractName: 'Contract Name',
    basicInformation: 'Basic Information',
    placeholder: 'Please Input',
    placeholderSelect: 'Please Select',
    prPortName: 'prPort',
    portName: 'Port',
    contType: 'Contract Type',
    contStatus: 'Contract Status',
    effectDate: 'Effect Date',
    shipTeam: 'Vessel Team',
    estRDate: '拟加油日期',
    startDatePlaceHolder: 'Start Date',
    endDatePlaceHolder: 'End Date',
    remark: 'Remark',
    contractNumberAndPrice: 'Contract Number And Price',
    unitPrice: 'Unit Price',
    oilTypeName: 'Oil Type',
    oilTypeName2: "<label style='color:red'>*</label>Oil Type",
    oilSpec: 'Spec',
    oilSpec2: "<label style='color:red'>*</label>Spec",
    oilQuantity: 'Oil Qty(ton)',
    oilQuantity2: '<label style=\'color:red\'>*</label>Oil Qty(ton)',
    fuelCharge: 'Fuel Charge',
    oilFloating2: '<label style=\'color:red\'>*</label>Oil Floating(%)',
    oilFloating: 'Oil Floating(%)',
    amount: 'Amount',
    // 货代大副收据明细界面
    // 基本信息表
    mateReceiptEdit: 'Mate Receipt Edit',
    soNo: 'SO No',
    carrier: 'Carrier',
    vesselName: 'Vessel Name',
    voyageNo: 'Voyage No',
    shipperDesc: 'Shipper Desc',
    consigneeDesc: 'Consignee Desc',
    notifyDesc: 'Notify Desc',
    pol: 'POL',
    pod: 'POD',
    marks: 'Marks',
    noOfPackage: 'No of Package',
    packageType: 'Package Type',
    grossWeight: 'Gross Weight',
    weightUnit: 'Weight Unit',
    goodsCube: 'Goods Cube',
    cubeUnit: 'Cube Unit',
    goodsDesc: 'Goods Desc',
    deckDesc: 'Deck Desc',
    mateRemark: 'Mate Remark',
    loadingDate: 'Loading Date',
    isLocked: 'Is Locked',
    createdBy: 'Created By',
    createdDate: 'Created Date',
    updatedBy: 'Updated By',
    updatedDate: 'Updated Date',
    //    关联提单号
    seqNo: 'Seq No',
    blNo: 'BL No',
    //    附件信息
    attachmentInfo: 'Attachment Information',
    no: 'No',
    attchmentType: 'Attchment Type',
    attchmentName: 'Attchment Name',
    uploadDate: 'Upload Date',
    uploadDept: 'Upload Dept',
    uploadUser: 'Upload User',
    refresh: 'Refresh',
    Read: 'Read',
    baseInformation: 'Base Information',
    chartererCode: 'Charterer Code',
    chartererName: 'Charterer Name',
    creator: 'Created By',
    createTime: 'Created Date',
    lastModifyBy: 'Updated By',
    lastModifyTime: 'Updated Date',
    timePlaceHolder: 'Please select a datetime',
    associateBl: 'Associate BL',
    errorMessage: 'Please try again',
    errorSoNo: 'The SoNo already exists and cannot be saved',
    pleaseSelect: 'Select',
    pleaseInput: 'Input',
    isSureCancel: 'Are you sure to cancel it',
    soDeleteCheck: 'The chief officer data is locked and cannot be deleted',
    copyBlTitle: 'Specify Bill of Lading Format',
    // 提单跟踪-提单保函管理页面
    blTracking: 'Bill of Lading Tracking',
    blLoiManagement: 'LOI Management',
    isOwnerFlag: 'Is Owner Flag',
    blReceivedFlag: 'Is Org. B/L received',
    isLitigation: 'Is Litigation',
    billReceiptTime: 'Date of Org. B/L received on',
    guaranteeReceiptTime: 'Date of Org. LOI received on',
    litigationPeriod: 'Litigation Period',
    litigationPeriod2: 'Litigation statute of limitations for non bill of lading delivery (months)',
    litigationEndTime: 'Litigation End Time',
    litigationFlag: 'Litigation flag',
    litigationMaintenance: 'Litigation period maintenance',
    litigationTitle: 'Litigation period maintenance',
    voyageGuaranteeLetter: 'Voyage Guarantee Management',
    countryCode: 'Code',
    countryNameCn: 'Name(CN)',
    countryNameEn: 'Name(EN)',
    charterer: 'Charterer',
    loiQty: 'LOI Qty',
    loiType: 'LOI Type',
    approvalStatus: 'Approval Status',
    voyageBlLoi: 'LOI for voyage',
    loiDate: 'LOI Date',
    relatedContract: 'Related Contract No',
    blLoiEdit: 'LOI Edit',
    submitForApproval: 'Submit for Approval',
    viewImages: 'Viewing image Files',
    otherInfo: 'Other Information',
    approvalHistory: 'Approval History',
    goodsCondition: 'Relevant data of goods',
    blSubmitCheck: 'The approval status of this bill of lading has not been approved and cannot be operated',
    // approvalHistory: 'Approval History',
    updateTime: 'Update Receipt Time',
    checkSoNo: 'View Chief Mate Receipt',
    checkBlNo: 'View Bill of Lading',
    checkContractNo: 'View contract number',
    invalidFlag: 'Is Invalid',
    loiConfirmFlag: 'Whether to confirm the guarantee',
    relatedContractFlag: 'Has the contract number been associated with it',
    releasedFlag: 'Release or not',
    retakeFlag: 'Whether the bill of lading is recovered',
    selectOneData: 'Please select a message',
    noSoNo: 'The chief mate receipt does not exist',
    noBlNo: 'The bill of lading does not exist',
    noContractNo: 'The Contract No does not exist',
    modifyOriginReceivedDate: 'Modify Origin Received Date',
    operationSuccessful: 'Operate Successfully',
    selectInvoiceType: 'Please select invoice type',
    operationFailed: 'operation failed',
    //  提单保函流程监控页面
    loiProcess: 'LOI Process Monitoring',
    voyageType: 'Voyage Type',
    cargoClass: 'Cargo Class',
    cargoGroup: 'Cargo Group',
    voyageEndTime: 'End time of voyage',
    blRecallEmail: 'Collection Email',
    cargoQuantity: 'Cargo Cargo Qty',
    discPort: 'Disc Port',
    ataFirst: 'ATA 1st Disport',
    loiApprovalStatus: 'LOI Approval Status',
    loiBuildDate: 'LOI Date',
    email: 'Email',
    send: 'Send',
    addressee: 'Addressee',
    carbonCopy: 'Carbon Copy',
    subject: 'Subject',
    blApprovalStatus: 'BL Approval Status',
    // 正本提单回收统计（按照船型）
    oblStatisticsCustomer: 'Original Bill of Lading Collection Statistics(by Customer)',
    labStaticShip: 'Original Bill of Lading Collection Statistics(by Ship)',
    dateTimeStatic: 'Date Time Static',
    customer: 'Charterer',
    voyageQty: 'Voyage Qty',
    voyageEndTimeFr: 'Voyage End Time Fr',
    voyageEndTimeTo: 'Voyage End Time To',
    loiReceivedVoyageQty: 'Org. B/L received Voyage Qty',
    loiUnreceivedVoyageQty: 'Org. B/L UnReceived Voyage Qty',
    receivedRate: 'Received Rate',
    isExistVesselAndVoyage: 'The ship name voyage already has a bill of lading template, which cannot be saved',
    save: 'save',
    uploadAttachments: 'Upload attachments',
    effectivenessOfContract: 'Effectiveness of contract',
    endOfContract: 'End of contract',
    contractNumber: 'Contract No',
    contractQuantityAndPrice: 'Contract quantity and price',
    unitPriceCompany: '<label style=\'color:red\'>*</label>Unit price (yuan/ton)',
    marketOilPrice: 'Market oil price',
    highSulfurHeavyOil: 'High sulfur heavy oil',
    lowSulfurHeavyOil: 'Low sulfur heavy oil',
    highSulfurLightOil: 'High sulfur light oil',
    lowSulfurLightOil: 'Low sulfur light oil',
    shipRefueling: 'Ship refueling',
    refuelingTime: 'Refueling time',
    balance: 'balance',
    enclosure: 'enclosure',
    fileName: 'file name',
    fileType: 'file type',
    fileSize: 'file size',
    refuelingQuery: 'Refueling query',
    payer: 'Payer',
    payType: 'Pay Type',
    emergencyProcurement: 'Emergency procurement',
    actualRefuelingdateFrom: 'Actual refueling date (from)',
    actualRefuelingDateEnd: 'Actual refueling date (end)',
    traders: 'Traders',
    spotContractNo: 'Spot contract No',
    oilOrderingDateFrom: 'Oil ordering date (from)',
    oilOrderingDateEnd: 'Oil ordering date (end)',
    futuresContract: 'Futures contract',
    futuresDate: 'Futures date',
    whetherFuturesOil: 'Whether futures oil',
    ownShip: 'Own ship',
    charterShip: 'Charter a ship',
    voyageNumber: 'Voyage number',
    operatingCompany: 'Operating company',
    signFor: 'Sign for',
    portName02: 'Port name',
    country: 'country',
    fuelAndHeavyOilSupplier: 'Fuel and heavy oil supplier',
    fuelAndLightOilSupplier: 'Fuel and light oil supplier',
    orderingDate: 'Ordering date',
    estimatedDate: 'Estimated date',
    actualDate: 'Actual date',
    createdOn: 'Created on',
    dateOfReceiptOfInvoice: 'Date of receipt of invoice',
    businessApprovalCompleted: 'Business approval completed Date',
    actualPaymentDate: 'Actual payment date',
    totalCost: 'Total cost',
    actualAmountHighsulfurHeavyOil: 'Actual amount of high-sulfur heavy oil',
    actualHighSulfurHeavyOilPrice: 'Actual high sulfur heavy oil price',
    actualAmountLowsulfurHeavyOilAdded: 'Actual amount of low-sulfur heavy oil added',
    actualLowSulfurHeavyOilPrice: 'Actual low sulfur heavy oil price',
    actualAmountHighSulfurLightOilAdded: 'Actual amount of high-sulfur light oil added',
    actualHighSulfurLightOilPrice: 'Actual high sulfur light oil price',
    actualAmountLowSulfurLightOilAdded: 'Actual amount of low-sulfur light oil added',
    actualLowSSulfurLightOilPrice: 'Actual low sulfur light oil price',
    estimatedAmountHighSulfurHeavyOil: 'Estimated amount of high-sulfur heavy oil',
    estimatedAmountLowSulfurJeavyOil: 'Estimated amount of low-sulfur heavy oil',
    estimatedAmountHighSulfurLightOil: 'Estimated amount of high-sulfur light oil',
    estimatedAmountLowSulfurLightOilAdded: 'Estimated amount of low-sulfur light oil added',
    marketPriceOfHighSulfurHeavyOil: 'Market price of high sulfur heavy oil',
    marketPriceOfLowSulfurHeavyOil: 'Market price of low sulfur heavy oil',
    marketPriceOfHighSulfurLightOil: 'Market price of high sulfur light oil',
    marketPriceOfLowSulfurLightOil: 'Market price of low sulfur light oil',
    highSulfurHeavyOilPriceInSingaporeMarket: 'High sulfur heavy oil price in Singapore market',
    lowSulfurHeavyOilPriceInSingaporeMarket: 'Low sulfur heavy oil price in Singapore market',
    highSulfurLightOilPriceInSingaporeMarket: 'High sulfur light oil price in Singapore market',
    lowSulfurLightOilPriceInSingaporeMarket: 'Low sulfur light oil price in Singapore market',
    termOilContractNo: 'Term oil contract No',
    invoice: 'invoice',
    printRefuelingBulkCargo: 'Print refueling application form (bulk cargo)',
    printRefuelingGroceries: 'Print refueling application form (groceries)',
    registerActualPaymentDate: 'Register actual payment date',
    printPaymentApplicationForm: 'Print payment application form',
    submitFinancialPayment: 'Submit financial payment',
    evaluateSuppliers: 'Evaluate suppliers',
    fuelApproval: 'Fuel approval',
    approvalList: 'Approval list',
    lockFuelReceipt: 'Lock fuel receipt',
    lockFuelReceiptLocal: 'Lock fuel receipt (local)',
    refuelingApplication: 'Refueling application',
    refuelingVoid: 'Refueling void',
    feeRegistration: 'Fee Registration',
    voyageInformation: 'Voyage information',
    HighLowSulfurHeavyOil: 'High/low sulfur heavy oil',
    futuresOilPrice: 'Futures oil price',
    totalAmountScheduledOil: 'Total price of scheduled oil',
    totalAmountActualOilPrice: 'Total amount of actual oil price',
    totalAmountmarketOilPrice: 'Total amount of market oil price',
    amountDifference: 'Amount difference',
    HighLowSulfurLightOil: 'High/low sulfur light oil',
    ton: 'ton',
    freshWaterStorage: 'Fresh water storage',
    purposeOfBerthing: 'Purpose of berthing',
    arrivalTime: 'arrival time',
    departureTime: 'Departure time',
    prepaidOrNot: 'Prepaid or not',
    prepaidCustomers: 'Prepaid customers',
    purchaseRemarks: 'Purchase remarks',
    refuelingInformation: 'Refueling information',
    supplierInquiry1: 'Supplier 1 and inquiry',
    supplierInquiry2: 'Supplier 2 and inquiry',
    supplierInquiry3: 'Supplier 3 and inquiry',
    refuelingEventRecord: 'Refueling event record',
    refuelingEvaluation: 'Refueling evaluation',
    oilSupplyContract: 'Oil supply contract',
    estimatedQuantity: 'Estimated quantity(MT)',
    actualQuantity: 'Actual quantity(MT)',
    sulfurContent: 'Sulfur content%',
    viscosityValue: 'Viscosity value',
    receiptPrice: 'Receipt price$/MT',
    paymentStatus: 'Payment status',
    actualSupplierLightOil: 'Actual supplier of light oil',
    refuelingType: 'Refueling type',
    viewFuturesContracts: 'View futures contracts',
    supplierAndPriceRefueling: 'Supplier and price of this refueling',
    expirationDate: 'Expiration date',
    actualSupplierHeavyOil: 'Actual supplier of heavy oil',
    otherExpenses: 'other expenses',
    cost: 'cost',
    costTab: 'cost tab',
    independentPayment: 'Independent payment',
    enquiry1: 'enquiry 1',
    enquiry2: 'enquiry 2',
    enquiry3: 'enquiry 3',
    eventType: 'Event type',
    responsibleParty: 'Responsible party',
    eventDescription: 'Event description',
    voyageStatus: 'Voyage Status',
    voyageTwo: 'Voyage No',
    startTime: 'COMM',
    endTime: 'COMP',
    portListing: 'Port Listing',
    route: 'Route',
    dispatcherName: 'Dispatcher Name',
    itemVoyageInfo: 'Voyage information',
    focusCode: 'Focus on the cause',
    startTitle: 'Port of entry and storage status',
    // arrivalTime: 'COMM',
    portCode: 'Star Port',
    unit: 'Tons',
    actDate: 'Bunkering Time',
    price: 'Price',
    titleOne: 'New ship voyage mission initialization',
    titleTwo: 'Arrange a new voyage',
    titleThree: 'Voyage information',
    description: 'description',
    titleDetail: 'Ship dispatch editor',
    register: 'Special event registration',
    voyageRemark: 'Voyage note',
    Lastvoyage: 'Last voyage',
    Nextoyage: 'Next voyage',
    Expenseitem: 'Expense item',
    voyageEnd: 'End of voyage',
    retirement: 'retirement',
    addTidan: 'New bill of lading guarantee',
    searchTidan: 'Query bill of lading',
    voyageday: 'Voyage Days',
    currency: 'Currency',
    Specialpoint: 'Special point',
    edit: 'Edit',
    more: 'more',
    Domestictrade: 'Domestic trade',
    Foreigntrade: 'Foreign trade',
    VoyageIsuselowspeed: 'Voyage Isuselowspeed',
    VoyageIscuout: 'Voyage Iscuout',
    isLoI: 'Is LOI',
    isSublet: 'Is Sublet',
    chaVygNo: 'Charterers voyage No',
    voyageIsdd: 'Voyage Isdd',
    planDockingDays: 'Plan Docking Days',
    local: 'Lay Can Time',
    isEscrowVoyage: 'Is Escrow Voyage',
    mulContractVoy: 'Multiple Voyage',
    specialTitle: 'Special point information',
    estimatedRefuelingTime: 'Estimated refueling time',
    shipSource: 'Ship source',
    vesselType: 'vessel type',
    keywordSearch: 'Keyword search',
    voyagePort: 'Voyage to port cargo',
    portName03: 'Port Name',
    portPurpose: 'Port Purpose',
    distance: 'Mileage',
    arrivalTimetwo: 'Return Time',
    aFoH: 'Arrival Hsfo',
    aDoH: 'Arrival Hsmgo',
    berthingTime: 'Berthing Time',
    departureGmtTime: 'Departure Time',
    dFoH: 'Departure Hsfo',
    dDoH: 'Departure Hsmgo',
    consumption: 'FO Consumption In Port',
    mgoPort: 'MGO In Port',
    sailingTime: 'Sailing Time',
    sailingOne: 'FO Consumption For Sailing',
    distanceOne: 'ESOP Distance to wharf',
    distanceTwo: 'Distance From Wharf to FA',
    portInsertion: 'Port insertion',
    portProxy: 'Port agent',
    portUp: 'Port move up',
    portMigration: 'Port migration',
    portMovement: 'Port movement',
    titleMessage: 'Voyage port information added',
    havaPda: 'Have PDA',
    anchorWork: 'ANCHOR WORK',
    havaFda: 'Have FDA',
    commGmt: 'COMM',
    compGmt: 'COMP',
    portInfo: 'Port information',
    portTime: 'Port Name/Time Zone',
    berthing: 'berthing',
    lastPortName: 'Previous Port Name',
    distanceO: 'Distance Between Ports',
    sailingTimeOne: 'Sailing Time',
    speed: 'Average Speed',
    esopTime: 'Esop Time',
    aBefDrf: 'Arrival Bow Draft',
    aMidDrf: 'Arrival Midship Draft',
    aAftDrf: 'Arrival Stern Draft',
    aWater: 'Arrival Water',
    highSulfurHeavyOilOne: 'ESOP Hsfo',
    lowSulfurHeavyOilOne: 'ESOP Lsfo',
    highSulfurLightOilOne: 'ESOP Hsmgo',
    lowSulfurLightOilOne: 'ESOP Lsmgo',
    highSulfurHeavyOilTne: 'Arrival Hsfo',
    lowSulfurHeavyOilTne: 'Arriva Lsfo',
    highSulfurLightOilTne: 'Arrival Hsmgo',
    lowSulfurLightOilTne: 'Arrival Lsmgo',
    highSulfurHeavyOilne: 'Departure Hsfo',
    lowSulfurHeavyOilne: 'Departure Lsfo ',
    highSulfurLightOilne: 'Departure Hsmgo',
    lowSulfurLightOilne: 'Departure Lsmgo ',
    ahighSulfurHeavyOilne: 'FA Hsfo',
    alowSulfurHeavyOilne: 'FA Lsfo',
    ahighSulfurLightOilne: 'FA Hsmgo',
    alowSulfurLightOilne: 'FA Lsmgo',
    aDa: 'Arrival Water',
    aEl: 'Arrival Engine Lubricating',
    aGl: 'Arrival Auxiliary Lubricating',
    aCl: 'Arrival Cylinder Lubricating',
    departureTimeOne: 'Departure Time',
    aBefDrfOne: 'Departure Bow Draft',
    aMidDrfOne: 'Departure Midship Draft',
    aAftDrfOne: 'Departure Stern Draft',
    aDaOne: 'Departure  Whose density',
    aWaterone: 'Departure Water',
    dEl: 'Departure Engine Lubricating',
    dGl: 'Departure Auxiliary Lubricating',
    dCl: 'Departure Cylinder Lubricating',
    faTime: 'FA',
    voyageMount: 'Voyage mount',
    voyageCargo: 'Voyage cargo',
    totalNumber: 'Total bill of lading',
    portCodenew: 'Loading Port',
    tFportCode: 'Discharge Port',
    cargoName: 'Cargo Name',
    loadQty: 'Load Quantity',
    contractQty: 'Estimated Quantity',
    unloadQty: 'Discharge Quantity',
    turnover: 'Turnover',
    Charterer: 'Charterer',
    goodsInfo: 'Cargo information',
    goodsDetail: 'Cargo details of the voyage',
    originArea: 'Origin',
    cargoQty: 'B/L Quantity',
    blDate: 'B/L Date',
    contractQtyOne: 'Contract Quantity',
    blNoO: 'B/L No',
    lgNo: 'Guarantee No',
    heatingCargo: 'HEATING_CARGO',
    temp: 'Fahrenheit',
    portCodeOne: 'Load Port',
    perDisQty: 'Quantity Before  Discharge',
    tiaokuan: 'Transportation Terms',
    refuelingApply: 'Refueling application',
    contractOne: 'Our contract',
    contractTwo: 'Escrow contract',
    contractTypeIn: 'Contract_Type',
    aDelTime: 'Delivery Time',
    aRedTime: 'Return Time',
    relectContract: 'Associated contract information',
    haveChange: 'Available for choice',
    alreadyHave: 'selected',
    outContract: 'Party out contract',
    nameContract: 'Minghua International/Singapore Contract',
    sureButton: 'Confirm import',
    close: 'close',
    returnShip: 'Expected return',
    handShip: 'Actual delivery',
    yuan: 'yuan',
    eRedHfoPrice: 'Estimate Red Hsfo Price',
    eRedLfoPrice: 'Estimate Red Lsfo Price',
    eRedHdoPrice: 'Estimate Red Hsmgo Price',
    eRedLdoPrice: 'Estimate Red Msmgo Price',
    eRedPorts: 'Estimate Red Time/Locat',
    eRedRemark: 'EstimateRed Remarks',
    cpNotice: 'Estimate Red Time',
    cpNoticeDesc: 'Remarks',
    returnActual: 'Actual return (master report)',
    aRedTimeLt: 'Captain Actual Red Local Time',
    aRedTimeOne: 'Captain Actual Red GMT Time',
    aRedPort: 'Captain Actual Red Port/Location',
    actualRe: 'Actual return (final claim)',
    waring: 'Note: If the final number is inconsistent with the captain number, you need to fill in the final number, otherwise it is not necessary',
    returnOil: 'Refuel after returning the ship',
    returnOilBack: 'Back Refuel after returning the ship',
    returnShipDeliver: 'Expected delivery',
    handShipDeliver: 'Actual delivery',
    eDelPorts: 'Estimate Del Time/Location',
    eDelRemark: 'stimate Del Remarks',
    cpNoticeOne: 'Estimate Del Time',
    returnActualDeliver: 'Actual delivery (reported by master)',
    aDelTimeLt: 'Actual Del Local Time',
    contractTitle: 'Voyage cargo contract rate and cargo volume maintenance',
    freightType: 'Charging Type',
    freightFee1: 'Price/lump/ws',
    calType: 'Quantity Calculation',
    contracthuo: 'Contract Quantity',
    tonyi: 'Over tons',
    cargoOqMin: 'Excess Quantity',
    cargoOqStandards: 'Freight Basis',
    warningNote: '* If it relates to the Minghua International/Singapore contract, it shall be amended simultaneously',
    actual: 'actual',
    anticipate: 'anticipate',
    messageVoyageNo: 'New ship, please go to the new ship voyage task initialization place to arrange the voyage task!',
    messageTwoVoyageNo: 'Only self-owned ships can be deployed during the initialization of the new voyage mission!',
    TimeInPort: 'Time In Port',
    exportSuccess: 'Import successfully',
    limitMessage: 'Only one item can be added',
    actualSupplier: 'Actual Supplier',
    fuelFeeRegistration: 'Fuel fee registration',
    invoiceDocument: 'Invoice/Document No',
    invoiceDocumentNo: "Invoice/Document No",
    costDescription: 'Cost Description',
    invoiceAmount: 'Invoice amount',
    dueDate: 'date due',
    submitFlag: 'Submit A/R&A/P',
    submitFlag02: 'Submit A/R',
    payee02: 'Payee',
    fuelCostInformation: 'Fuel Cost Information',
    registerReceiptDateInvoice: 'Register receipt date of invoice',
    updateDate: 'update Date',
    refuelingPort: 'Refueling port',
    payer02: 'Payer',
    oilSupplier: 'Oil supplier',
    refuelingContract: 'Refueling contract',
    receiptComplete: 'Receipt Complete',
    expensesAndReceipts: 'expenses and receipts',
    expensesAndReceipts2: "<label style='color:red'>*</label> expenses and receipts",
    isIncludesTax: 'Whether the price includes tax',
    isIncludesTax2: "<label style='color:red'>*</label> Whether the price includes tax",
    taxRate: 'tax rate',
    taxRate2: "<label style='color:red'>*</label> tax rate",
    invoiceQuantity: 'Invoice Quantity',
    invoiceQuantity2: "<label style='color:red'>*</label> Invoice Quantity",
    invoiceUnitPrice: 'Invoice unit price',
    invoiceUnitPrice2: "<label style='color:red'>*</label> Invoice unit price",
    financialApportionmentAmount: 'Financial apportionment amount',
    purchaseQuantity: 'Purchase quantity',
    purchaseUnitPrice: 'Purchase unit price',
    purchaseAmount: 'Purchase amount',
    fuelInformation: 'Fuel information',
    settlementObject: 'Settlement object',
    ourClearingCompany: 'Our clearing company',
    fuelContractNumber: 'Fuel contract number',
    withdrawalFuelReceipt: 'Withdrawal of fuel receipt',
    pricingMethod: 'pricing method',
    generatePreReport: 'Generate Advance Report',
    generateSettlementReport: 'Generate Settlemetn Report',
    viewPreReport: 'View Advance Report',
    viewSettlementReport: 'View Settlemetn Report',
    generatePreConfirm: 'Is Sure to Generate Advance Report?',
    generateSettlementConfirm: 'Is Sure to Generate Settlement Report?',
    shipManager: 'Ship Manager',
    charteringName: 'Chartering Name'
  },
  routeInCommonData: {
    route: 'route',
    fleet: 'fleet',
    keyword: 'keyword',
    code: 'code',
    enName: 'En Name',
    cnName: 'Cn Name',
    inFleet: 'Applicable fleet',
    shippingLineType: 'Shipping Line Type',
    tradingArea: 'Trading Area',
    status: 'status',
    lastModifyBy: 'Last Modify By',
    lastModifyTime: 'Last Modify Time'
  },
  tor: {
    oneTitle: 'Scheduling management',
    twoTitle: 'Ship message management',
    inShipContract: 'Message monitoring management',
    leftTitle: 'Ship information',
    rightTitle: 'Message information',
    haveRu: 'The packet is stored. Procedure',
    haveBad: 'Discarded message',
    type: 'Message type',
    errorMessage: 'Error message',
    reportTn: 'Report No',
    reportTm: 'Report Time',
    timeZone: 'Report Zone',
    reportFlag: 'report fro',
    errorInfo: 'Error Report',
    warehousing: 'Put in storage',
    abandon: 'abandon',
    mark: 'Mark entry',
    successWare: 'Storage success',
    abandomError: 'Successful operation'
  },
  //报文综合查询
  allReport: {
    fleet: 'Fleet',
    vesselName: 'Vessel Name',
    vygNo: 'Voyage No',
    reportTm: 'Report Time',
    timeZone: 'Time Zone',
    reportType: 'Report Type',
    reportTn: 'Report Tn',
    ngstatus: 'Navigational Status',
    sailingStatus: 'Vessel Status',
    port: 'Port',
    crs: 'Course',
    avgSpd: 'Average Speed',
    costfoday: 'Cost FO',
    avgRevolutionPerMin: 'Average Revolution',
    slip: 'Slip',
    runHrs: 'Run Hours',
    runDist: 'Run Distance',
    wind: 'Wind',
    wave: 'Wave',
    swell: 'Swell',
    cfo: 'Consume FO(H/L)',
    sfo: 'Storage FO(H/L)',
    cmgo: 'Consume MGO(H/L)',
    smgo: 'Storage MGO(H/L)',
    refue: 'Refuel',
    costmgoday: 'Cost MGO',
    remark: 'Remark',
    receivedTm: 'Received Time',
    reportStatus: 'Report Status',
    checkStatus: 'Check Status'
  }
};